import React from 'react'
import { observer } from 'mobx-react'
import { Container, Row, Col } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'
import { personalOfferContainer } from 'src/models/PersonalOffer'

// Skeleton shown while the PO API chain (`loadRequiredAPIforPO`) is in
// flight. Renders nothing when the flag is false.
@observer
class PersonalOfferPDPLoader extends React.Component {
  render() {
    if (!personalOfferContainer?.isPersonalOfferLoading) {
      return null
    }
    return (
      <Container
        fluid
        className="personal-offer-pdp-loader py-4"
        data-testid="qa-personal-offer-pdp-loader">
        <Row>
          <Col xs={12} md={6} className="my-2">
            <Skeleton rectangle height={400} width="100%" />
          </Col>
          <Col xs={12} md={6} className="my-2">
            <Skeleton rectangle height={30} width="60%" />
            <div className="mt-3">
              <Skeleton rectangle height={20} width="40%" />
            </div>
            <div className="mt-3">
              <Skeleton rectangle height={20} width="80%" count={3} />
            </div>
            <div className="mt-4">
              <Skeleton rectangle height={50} width="100%" />
            </div>
          </Col>
        </Row>
      </Container>
    )
  }
}

export { PersonalOfferPDPLoader }
export default PersonalOfferPDPLoader
